export default class AppRoutes {
    static root = "/";
    static adminPanel = "/adminPanel";
    static booksPage = "/booksPage";
    static homePage = "/homePage";
    static userHistoryPage = "/historyPage";
    static contactPage = "/contactPage";
}